import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-order-history-desktop-skeleton',
  templateUrl: './order-history-desktop-skeleton.component.html',
  styleUrl: 'order-history-desktop-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class OrderHistoryDesktopSkeletonComponent {
}
